/**
 * API Configuration
 *
 * URLs are injected at runtime via window.__APP_CONFIG__ (see public/config.js).
 * The container entrypoint (run-service-podman.sh) generates config.js from env vars.
 *
 * Local dev: Vite proxy handles /admin-api and /api-identity (see vite.config.ts).
 * Container: config.js sets the correct base URLs for the deployment.
 */

declare global {
  interface Window {
    __APP_CONFIG__?: {
      ADMIN_API_BASE_URL?: string;
      IDENTITY_API_BASE_URL?: string;
    };
  }
}

export const API_CONFIG = {
  // Local dev: Vite proxies /admin/v1/* to BFF at localhost:8211
  // Container: runtime config sets /api-admin/admin (ingress rewrites /api-admin/* -> /*)
  adminApiBaseUrl: window.__APP_CONFIG__?.ADMIN_API_BASE_URL ?? '/admin',
  identityBaseUrl: window.__APP_CONFIG__?.IDENTITY_API_BASE_URL ?? '/api-identity',
};
